var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 88,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F5DF4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.796 53.376a.947.947 0 1 0 0-1.894.947.947 0 0 0 0 1.894Zm0 1.42a2.367 2.367 0 1 0 0-4.734 2.367 2.367 0 0 0 0 4.734ZM28.865 37.742v2.928l-3.53 3.002v3.26a2.522 2.522 0 1 0 1.513 0v-2.561l3.53-3.002v-3.627h-1.513ZM27.1 49.338a1.008 1.008 0 1 1-2.016 0 1.008 1.008 0 0 1 2.016 0ZM50.796 42.28v1.512h-1.513v-1.513h1.513ZM50.796 37.742v3.53h-1.513v-3.53h1.513ZM32.142 56.396a1.008 1.008 0 1 0 0-2.016 1.008 1.008 0 0 0 0 2.016Zm0 1.513a2.52 2.52 0 1 0 0-5.042 2.52 2.52 0 0 0 0 5.042ZM39.52 49.684v-11.46h1.521v12.03l-2.029 2.25v8.21H37.49v-8.78l2.03-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.601 43.713v-5.488h1.522v6.06l-2.029 2.26v7.66l-1.522-.593v-7.64l2.03-2.259ZM45.502 37.742h-1.513v9.84l2.017 2.691v9.263a2.522 2.522 0 1 0 1.512 0V49.77l-2.016-2.691v-9.336Zm2.268 24.2a1.008 1.008 0 1 1-2.016 0 1.008 1.008 0 0 1 2.016 0ZM54.062 38.225h1.521v2.746l2.03 1.28v1.892H56.09v-1.182l-2.03-1.28v-3.456ZM33.451 11v1.53h1.463V11H33.45Zm3.9 0v6.119h1.462V11H37.35ZM25.683 29.939c.342-5.165 3.457-9.513 7.767-11.36v-5.03h1.463v6.119h-.038c-4.48 1.464-7.76 5.914-7.76 11.218 0 1.327.205 2.6.583 3.787h-1.261c-.09 0-.18.003-.268.007a14.07 14.07 0 0 1-.517-3.558c0 .134.002.267.006.4h-7.59c-.848 0-1.535.709-1.535 1.583 0 .875.687 1.583 1.535 1.583h7.96a5.523 5.523 0 0 0-3.49 1.583h-4.47a2.984 2.984 0 0 1-1.59-.457v27.07c0 2.534 1.988 4.587 4.44 4.587V69C17.648 69 15 66.262 15 62.884V32.898c0 .033 0 .067.002.1.054-1.7 1.407-3.06 3.067-3.06h7.615ZM15 32.898v-.592h.061c-.04.191-.061.39-.061.592Zm34.995 1.775h-1.53c.378-1.186.583-2.46.583-3.787 0-5.304-3.281-9.754-7.76-11.218h-.038V16.1h1.462v2.48c4.31 1.847 7.425 6.195 7.767 11.36h5.95v4.734h-1.535v-3.151h-4.39a13.947 13.947 0 0 0 .006-.517 14.072 14.072 0 0 1-.514 3.668ZM41.25 15.08v-1.53h1.462v1.53H41.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.183 24.483h1.008v-1.866h1.513v1.888c.823.08 1.52.382 2.093.903.69.617 1.034 1.392 1.034 2.323 0 1.04-.435 1.888-1.306 2.541.58.29 1.034.702 1.36 1.235.34.532.509 1.119.509 1.76 0 .527-.105 1.01-.315 1.45h-2.374c.09-.063.176-.135.257-.216.375-.363.563-.816.563-1.361 0-.544-.188-.998-.563-1.361-.363-.363-.823-.545-1.38-.545H35.21v3.483h-1.815V24.483h2.276v-1.866h1.513v1.866Zm-3.79 12.25h6.2-6.2Zm1.816-10.562h4.029c.496 0 .907.163 1.234.49.327.314.49.713.49 1.197 0 .484-.163.89-.49 1.216-.327.315-.738.472-1.234.472h-4.03v-3.375Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.562 36.166H26.438c-2.217 0-4.015 1.782-4.015 3.98v27.362h43.153v-9.16h-7.094c-3.095 0-5.605-2.65-5.605-5.92 0-3.268 2.51-5.917 5.605-5.917h7.094v-6.365c0-2.198-1.797-3.98-4.014-3.98Zm5.52 10.345v-6.365c0-3.022-2.472-5.472-5.52-5.472H26.438c-3.049 0-5.52 2.45-5.52 5.472V69h46.163V58.347h2.368V46.511H67.08Zm-8.6 1.543h9.504v8.75h-9.504c-2.288 0-4.143-1.96-4.143-4.375 0-2.416 1.855-4.375 4.143-4.375Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 84.448,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.870833 0 0 0 0 0.731472 0 0 0 0 0.14151 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_744_4845"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_744_4845",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurse);
export default __webpack_public_path__ + "static/media/purse.146b63e4.svg";
export { ForwardRef as ReactComponent };